var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGoogleCloud(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 52,
    viewBox: "0 0 64 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_696_1007)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M42.5629 14.3426L48.1262 8.7253L48.4969 6.36005C38.3592 -2.94769 22.2439 -1.8923 13.1052 8.56223C10.5667 11.4659 8.68345 15.086 7.6792 18.8242L9.6717 18.5407L20.798 16.6881L21.6569 15.8011C26.6062 10.3128 34.9744 9.57446 40.6889 14.2441L42.5629 14.3426Z",
    fill: "#EA4335"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.0513 18.659C54.7725 13.9042 52.1473 9.6299 48.497 6.36021L40.689 14.244C43.986 16.9642 45.8643 21.0621 45.7838 25.3601V26.7596C49.6215 26.7596 52.733 29.9011 52.733 33.7761C52.733 37.6513 49.6215 40.714 45.7838 40.714H31.866L30.4995 42.2119V50.6279L31.866 51.9483H45.7838C55.7663 52.0268 63.9218 43.9984 63.9995 33.9189C64.0465 27.8094 61.0633 22.0819 56.0513 18.659Z",
    fill: "#4285F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9677 51.9484H31.8659V40.7139H17.9677C16.9774 40.7137 16.0184 40.4988 15.1179 40.0833L13.1462 40.6942L7.54391 46.3115L7.05591 48.2234C10.1977 50.6186 14.0309 51.9656 17.9677 51.9484Z",
    fill: "#34A853"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9676 15.5055C7.98483 15.5655 -0.059172 23.7856 0.000327965 33.865C0.033578 39.4936 2.63708 44.7921 7.05583 48.2233L15.1178 40.0833C11.6201 38.4877 10.0658 34.3315 11.6461 30.8C13.2261 27.2686 17.3426 25.6992 20.8398 27.2946C22.3811 27.9976 23.6153 29.2441 24.3116 30.8L32.3736 22.66C28.9433 18.1322 23.6133 15.485 17.9676 15.5055Z",
    fill: "#FBBC05"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_696_1007"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 52,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleCloud);
export default __webpack_public_path__ + "static/media/google-cloud.d3e13a41fbd6a3dfbc0a62c4189b78c8.svg";
export { ForwardRef as ReactComponent };